import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";
  import {dictApi, mechanismApi, userApi} from "@/api/organization";
  import {Message, MessageBox} from "element-ui";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'bang-ding-org',
  emits: ['on-success'],
  setup(__props, { expose, emit: temit }) {

  const bangDingDialog = ref({
    visible: false,
    keywords: '',
    orgList: [],
    currentRow: null as any
  });
  const mechanismTypeList = ref([]);
  const {CodeToText, regionData} =require("@/js/region/region");
  const tableRef = ref();

  // eslint-disable-next-line no-undef
  

  const openDialog = () => {
    bangDingDialog.value.visible = true;
    listDict();
  }

  const refresh = () => {
    listOrg();
  }

  const bindOrg = () => {
    const row = bangDingDialog.value.currentRow;
    if (!row) {
      Message.warning("请选择您要绑定的单位");
      return;
    }
    MessageBox.confirm(
        '请确认您要绑定的单位【' + row.name + '】？',
        '操作提示',
        {
          confirmButtonText: '确认绑定',
          cancelButtonText: '取消绑定',
          type: 'warning',
        }
    ).then(() => {
      const orgId = row.id;
      const orgName = row.name
      userApi.bind({orgId: orgId}).then((r) => {
        if (r.data.result === 0) {
          bangDingDialog.value.visible = false;
          temit('on-success', orgName);
        }
      })
    });
  }

  const listOrg = () => {
    if(bangDingDialog.value.keywords.length < 4){
      Message.warning("请输入您要绑定的单位名称，至少4个字符");
      return;
    }
    bangDingDialog.value.currentRow = null;
    mechanismApi.list({
      name: bangDingDialog.value.keywords,
      current: 1,
      size: 50,
      status: 1
    }).then((r: any) => {
      if (r.data.result === 0) {
        bangDingDialog.value.orgList = r.data.data.records;
      }
    });
  }
  const listTypeName = (ids:string) => {
    const arr = ids?ids.split(","):[];
    const arr2 = [] as any;
    arr.forEach((e:any)=>{
      const obj = mechanismTypeList.value.find((e2:any)=>e2.dictKey == e) as any;
      if(obj){
        arr2.push(obj.dictValue);
      }
    })
    return arr2.length>0?arr2.join(","):"-";
  }


  const listDict = () => {
    //单位类别
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        const dataList = r.data.data;
        mechanismTypeList.value = dataList;
      }
    });
  }

  // eslint-disable-next-line no-undef
  expose({
    openDialog
  });

return { __sfc: true,bangDingDialog, mechanismTypeList, CodeToText, regionData, tableRef, temit, openDialog, refresh, bindOrg, listOrg, listTypeName, listDict }
}

})